import { filterType, user_roles } from "../../../utils"

export const filterComponent = (state, props) => {

  let id = state?.id

  switch (props?.auth_data?.data?.user_role) {
    case user_roles.super_admin: {
      return {
        section_1: {
          label: "Filters",
          fields: {
           
            status: {
              key: "status",
              id:`selectStatusFilterFrom${id ? id : ""}`,
              type: filterType.STATUS,
              breakPoints: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
              },
              label: "BY  STATUS",
              value: state.status,
              isMulti: true,
              isMandatory: true,
            },
            // sort: {
            //   key: "sortDirec",
            //   type: filterType.SORTDIRECTION,
            //   breakPoints: {
            //     xs: 12,
            //     sm: 12,
            //     md: 12,
            //     lg: 12,
            //     xl: 12,
            //   },
            //   label: "SORT BY",
            //   value: state.sortDirec,
            //   isMandatory: true,
            // },
          }
        }
      }
    }

    case user_roles.provider: {
      return {
        section_1: {
          label: "Filters",
          fields: {

            status: {
              key: "status",
              id:`selectStatusFilterFrom${id ? id : ""}`,
              type: filterType.STATUS,
              breakPoints: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
              },
              label: "BY STATUS",
              value: state.status,
              isMulti: true,
              isMandatory: true,
            },
            // sort: {
            //   key: "sortDirec",
            //   type: filterType.SORTDIRECTION,
            //   breakPoints: {
            //     xs: 12,
            //     sm: 12,
            //     md: 12,
            //     lg: 12,
            //     xl: 12,
            //   },
            //   label: "SORT BY",
            //   value: state.sortDirec,
            //   isMulti: true,
            //   isMandatory: true,
            // },
          }
        }
      }
    }

    default: return {
      
        section_1: {
          label: "Filters",
          fields: {

            status: {
              key: "status",
              id:`selectStatusFilterFrom${id ? id : ""}`,
              type: filterType.STATUS,
              breakPoints: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
              },
              label: "BY STATUS",
              value: state.status,
              isMulti: true,
              isMandatory: true,
            },
            // sort: {
            //   key: "sortDirec",
            //   type: filterType.SORTDIRECTION,
            //   breakPoints: {
            //     xs: 12,
            //     sm: 12,
            //     md: 12,
            //     lg: 12,
            //     xl: 12,
            //   },
            //   label: "SORT BY",
            //   value: state.sortDirec,
            //   isMulti: true,
            //   isMandatory: true,
            // },
          }
        }
      }
    }
}